(function ( $ ) {
    $.fn.defaultMessageSelector = function(val, params) {
        $(this).each(function() {
            var elm = $(this);

            elm.attr('data-search-type', 'default_message');

            var onChange = function(obj) {
                if(typeof obj == 'string') {
                    obj = JSON.parse(obj);
                }
                elm.removeClass('has-special-selector').defaultMessageSelector(obj.id, params);
            };

            elm.specialSelector({
                params: params,
                val: val,
                option: function(row) {

                    var nameStr = row.name;
                    //if(row.company) {
                    //    nameStr = nameStr+' ('+row.company.name+')';
                    //}
                    return '<option value="'+row.id+'">'+nameStr+'</option>';
                },
                addNew: function() {
                    add_default_message({
                        filters: elm.getSetFilters(),
                        callback: function(default_message) {
                            onChange(default_message);
                        }.bind([elm])
                    });
                }.bind([elm]),
                onOpen: function(id) {
                    view_default_message(id, {callback: function(default_message, elm, popup) {
                        onChange(default_message);
                        popup.close();
                    }});
                }
            });
        });
        return this;
    };

}( jQuery ));